import React from 'react'
import { useSearchParams } from 'react-router-dom';
import System from 'src/helper/system';
import useReduxState from 'src/hooks/useReduxState';
import Order from '@system/config/order';
import CommonOrderDetail from '../../CommonOrderDetail';

let c = System.getParams();

const OrderDetailTabsData = (props) => {
    const [searchParams] = useSearchParams();
    const [OrderDetailTabList__Component__Loader, Set_OrderDetailTabList__Component__Loader] = useReduxState(searchParams.get(CommonOrderDetail.param_key_OrderDetailTabList) ? searchParams.get(CommonOrderDetail.param_key_OrderDetailTabList) : CommonOrderDetail.default_component.param_value, CommonOrderDetail.redux_key_OrderDetailTabList);

    const getActiveClass = (singleElement) => {
        if (CommonOrderDetail.chain_OrderDetailTabList[OrderDetailTabList__Component__Loader].param_value === singleElement.param_value) {
            return 'active'
        }
        return ''
    };

    const getTabLink = (singleElement) => {
        return Order.getOrderDetailTabsListRouteURL({
            ...c,
            [CommonOrderDetail.param_key_OrderDetailTabList]: singleElement.param_value
        });
    };

    const switchTab = async (url, chain_single) => {
        history.pushState('', '', url);
        Set_OrderDetailTabList__Component__Loader(chain_single.param_value);
    };
    return (
        <>
            <ul className="bs5 nav nav-tabs m-t-20">
                {Object.entries(CommonOrderDetail.chain_OrderDetailTabList).map((v) => (
                    <React.Fragment key={v[1].name}>
                        <li className={'maxw-auto'} key={v[1].name}>
                            <a className={'text-uppercase font-bold ' + getActiveClass(v[1])}
                                href={void (0)}
                                onClick={async () => {
                                    await switchTab(getTabLink(v[1]), v[1])
                                }}
                            >
                                <span>{v[1].name}</span>
                            </a>
                        </li>
                    </React.Fragment>
                ))
                }
            </ul>

            <div className="tab-content p-0 border-0" id={CommonOrderDetail.chain_OrderDetailTabList[OrderDetailTabList__Component__Loader].param_value}>
                {React.createElement(CommonOrderDetail.chain_OrderDetailTabList[OrderDetailTabList__Component__Loader].element, props)}
            </div>
        </>
    )
}

export default OrderDetailTabsData